import router from "../../router";
import { login, controlDomain } from "../../services/modules/login.js";
import { showProcessErrorMessage } from "../alertHelpers";
import jwt_decode from "jwt-decode";
import { getSingle } from "@/services/modules/user/userService";
import { swalToast } from "@/helpers/swalToast";
import store from "@/state/store";

export const state = {
  domainActive: false,
  user: null,
  token: null,
  loginLoadingStatus: false,
  showCustomerModal: false,
  redirectUrl: "",
};

export const mutations = {
  setUser(state, newValue) {
    state.user = newValue;
  },
  setToken(state, newValue) {
    state.token = newValue;
  },
  setLoginLoadingStatus(state, newValue) {
    state.loginLoadingStatus = newValue;
  },
  unsetUser(state) {
    state.user = null;
  },
  unsetToken(state) {
    state.token = null;
  },
  setShowCustomerModal(state, data) {
    state.showCustomerModal = data;
  },
  prepareShowCustomerModal(state, data) {
    state.showCustomerModal = data;
  },
  setUrlToRedirect(state, newValue) {
    state.redirectUrl = newValue;
  },
  setDomainActive(state, data) {
    state.domainActive = data;
  },
};

export const getters = {
  getUser(state) {
    return state.user;
  },
  getUrlToRedirect(state) {
    return state.redirectUrl;
  },
};

export const actions = {
  async prepareShowCustomerModal(context) {
    context.commit("prepareShowCustomerModal", false);
  },

  async tryLogin(context, { username, password }) {
    let response = await login(username, password);
    if (response.error) {
      showProcessErrorMessage({
        title: "Giriş Yapılamadı",
        text: response.data.message,
      });
    } else {
      try {
        let domainResponse = await controlDomain(
          `${localStorage.getItem("currentUrl")}`
        );
        if (domainResponse.status === 200) {
          context.commit("setDomainActive", true);
        } else {
          context.commit("setDomainActive", false);
        }
      } catch (error) {
        error;
        context.commit("setDomainActive", false);
      }

      if (response.status) {
        let userInfo = jwt_decode(response.data.token);
        context.commit("setUser", userInfo);
        context.commit("setToken", response.data.token);
        await context.dispatch("getLoggedUser", {
          params: {},
          body: {},
          urlSegments: [context.state.user.UserId],
        });
        await context.dispatch(
          "settings/fetchSettings",
          { params: {}, body: {} },
          { root: true }
        );
        if (
          userInfo.RoleGroupId === 3 ||
          (userInfo.RoleGroupId === "3" &&
            store.state.settings.erpSettings.currencyCurrentProcess)
        ) {
          context.commit("setShowCustomerModal", true);
          return;
        }
        await swalToast.fire({
          icon: "success",
          title: "Giriş Başarılı",
          text: "Ana sayfaya yönlendiriliyorsunuz",
          iconColor: "green",
        });
        await router.push(
          state.redirectUrl && !state.redirectUrl.includes("login")
            ? state.redirectUrl
            : "/"
        );
        state.redirectUrl = "";
      } else {
        showProcessErrorMessage({
          title: "Giriş Yapılamadı",
          text: response.data.message,
        });
      }
    }
  },

  async getLoggedUser(context, { params, body, urlSegments }) {
    let result = await getSingle(params, body, urlSegments);
    if (result.data.success) {
      context.state.user.userInfo = result.data.data;
      context.commit("setUser", context.state.user);
    }
    return result;
  },

  logout({ commit }) {
    commit("unsetUser");
    commit("unsetToken");
    commit("prepareShowCustomerModal", false);
    state.redirectUrl = "";
    router.push("/login");
  },
};
